import * as React from "react";
import { Paragraph } from "scuid-x";
import { GenErrorPage } from "../components/GenErrorPage";

export const PathNotFound: React.SFC<any> = () => {
  const description = (
    <Paragraph>
      Path Not Found
    </Paragraph>
  );

  return (
    <GenErrorPage
      title="Error: 404"
      description={description}
    />
  );
};



// WEBPACK FOOTER //
// ./src/screens/PathNotFound.tsx